import { ACTIONS, TAX } from '../../modules/constants';
import precise from '../../modules/precise';
import getCountyDiscretionaryTax from '../../modules/getCountyDiscretionaryTax.js';

const SET_SALES_PRICE = 'fcr/salestaxes/SET_SALES_PRICE';
const SET_SALES_TAX_CONSOLE = 'fcr/salestaxes/SET_SALES_TAX_CONSOLE';
const SET_TAX_COUNTY = 'fcr/salestaxes/SET_TAX_COUNTY';
const SET_CREDIT_AMOUNT = 'fcr/salestaxes/SET_CREDIT_AMOUNT';
const RESET_SALES = 'fcr/salestaxes/RESET_SALES';

const INITIAL_STATE = {
  salesPrice: '0.00',
  floridaSalesTax: '0.00',
  countyDiscretionaryTax: 0,
  creditAmount: 0,

  // set these to whatever you want
  // as the default county.
  taxCountyName: 'Manatee',
  taxCountyFee: 0.01,
  taxCountySelectedValue: 'Manatee|0.01',
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case ACTIONS.RESET:
    case ACTIONS.RESET_ALL_EXCEPT_MONTH:
    case RESET_SALES:
      return {
        ...INITIAL_STATE,
      };
    case SET_SALES_PRICE:
      return {
        ...state,
        salesPrice: action.price,
        floridaSalesTax: precise(Number(action.price) * TAX.FLORIDA_SALES_TAX),
        countyDiscretionaryTax: precise(getCountyDiscretionaryTax(action.salesPrice, state.taxCountyFee)),
      };
    case SET_CREDIT_AMOUNT:
      return {
        ...state,
        creditAmount: action.amount,
      };
    case SET_TAX_COUNTY:
      return {
        ...state,
        taxCountyName: action.name,
        taxCountyFee: action.fee,
        taxCountySelectedValue: action.selectedValue,
        countyDiscretionaryTax: precise(getCountyDiscretionaryTax(state.salesPrice, action.fee)),
      };
    default:
      return state;
  }
}

export function setSalesPrice(price) {
  return {
    type: SET_SALES_PRICE,
    price,
  };
}

export function setSalesTaxConsole(text) {
  return {
    type: SET_SALES_TAX_CONSOLE,
    text,
  };
}

export function setTaxCounty(name, fee, selectedValue) {
  return {
    type: SET_TAX_COUNTY,
    fee,
    name,
    selectedValue,
  };
}

export function setCreditAmount(amount) {
  return {
    type: SET_CREDIT_AMOUNT,
    amount,
  };
}

export function resetSales(amount) {
  return {
    type: RESET_SALES,
    amount,
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/salestaxes.js